/** @jsxImportSource @emotion/react */

import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { Screen } from "../components";
import { getRecords } from "../utils/record";
import * as colors from "../styles/colors";
import { small } from "../styles/media-queries";

function Records() {
  return (
    <Screen>
      <RecordsList />
    </Screen>
  );
}

function RecordsList() {
  const { isLoading, isIdle, data: records } = useQuery("records", getRecords);

  if (isLoading || isIdle) return <p>Fetching Records...</p>;

  return (
    <div>
      {records.map((recordAddress) => (
        <RecordCard key={recordAddress} recordAddress={recordAddress} />
      ))}
    </div>
  );
}

function RecordCard({ recordAddress }) {
  return (
    <Link
      to={`/records/${recordAddress}`}
      css={{
        textDecoration: "none",
        color: colors.secondary,
        borderRadius: "0.3em",
        margin: "1em",
        padding: "1em",
        display: "block",
        backgroundColor: colors.white,
        fontWeight: 900,
        [small]: {
          fontSize: "0.7em",
        },
      }}
    >
      {recordAddress}
    </Link>
  );
}

export default Records;
